import ReactGA from 'react-ga4';

export const GA_TRACKING_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || '';
const MODE = import.meta.env.MODE;

export function initGA() {
  if (!GA_TRACKING_ID) {
    if (MODE !== 'production') {
      console.warn('GA not initialized: missing GA_TRACKING_ID');
    }
    return;
  }
  ReactGA.initialize(GA_TRACKING_ID, {
    testMode: MODE === 'development',
    gtagOptions: {
      debug_mode: MODE === 'development',
    }
  });
}

export function trackPageView(path: string) {
  if (!GA_TRACKING_ID) return;
  ReactGA.send({
    hitType: 'pageview',
    page: path,
  });
}

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackEvent(
  action: string,
  label: string,
  category: string = 'User Action',
  details: Record<string, any> = {}
) {
  if (!window.gtag) {
    console.warn('gtag not available');
    return;
  }

  const payload: Record<string, any> = {
    event_category: category,
    event_label: label,
    ...details,
  };

  window.gtag('event', action, payload);
}

